import { render, staticRenderFns } from "./downloadlist.vue?vue&type=template&id=79718e54&scoped=true&"
import script from "./downloadlist.vue?vue&type=script&lang=js&"
export * from "./downloadlist.vue?vue&type=script&lang=js&"
import style0 from "./downloadlist.vue?vue&type=style&index=0&id=79718e54&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79718e54",
  null
  
)

export default component.exports